export default __webpack_public_path__ + "static/media/lichtschriftlogoschwarz.e2bb355a.png";